import {jsx as _jsx} from "react/jsx-runtime";import {useState} from 'react'
import GenericAuthentication, {} from './GenericAuthentication'






const InvitationLinkAuthentication = (props) => {
  const [page, setPage] = useState('create-account')
  const goToPage = (page) => {
    setPage(page)
  }
  return _jsx(GenericAuthentication, { ...props, goToPage: goToPage, page: page,} )
}

export default InvitationLinkAuthentication
